import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { bytesToString } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RecoverableItemSizeTooltip',
    props: {
        data: null,
        isRecoverable: { type: Boolean },
        isArchived: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive);
        const label = computed(() => props.data?.label ?? "No data");
        const prettySize = computed(() => bytesToString(props.data?.value ?? 0));
        return { __sfc: true, props, label, prettySize, FontAwesomeIcon };
    }
});
